<template>
  <div class="tutorial-modal p-4" v-if="visible">
    <p class="text-start fw-bold" v-if="title">{{ title }}</p>
    <slot />
    <button class="acry-btn position-absolute"
      style="width:105px; height:40px; border-radius: 40px; right: 18px;"
      @click="$emit('close')">
      OK
    </button>
    <div v-if="showArrow" class="position-absolute" :style="{ right: '-15px', top: arrowTop }">
      <svg xmlns="http://www.w3.org/2000/svg" width="34" height="32" viewBox="0 0 34 32" fill="none">
        <path d="M33.1075 15.0974C33.8669 15.4596 33.8669 16.5404 33.1075 16.9026L1.93048 31.7722C1.26683 32.0888 0.499998 31.6049 0.499999 30.8696L0.5 1.13037C0.5 0.395104 1.26683 -0.0887492 1.93048 0.227774L33.1075 15.0974Z" fill="white"/>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: "TutorialModal",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    showArrow: {
      type: Boolean,
      default: true,
    },
    arrowTop: {
      type: String,
      default: "40px",
    },
  },
  emits: ["close"],
};
</script>

<style lang="scss">
.tutorial-modal {
  position: fixed;
  z-index: 3;
  background: white;
  border-radius: 4px;
}
</style>
